import { id, group, Identifiable, Group } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { reduceResource } from "../resource";
import { reduceProjectResource } from "../projectResource";
import {
  handleEditRequest,
  handleEditSuccess,
  handleEditFailure,
} from "./editResourceGroup";
import {
  handleAddEveryoneToResourceGroupSuccess,
  handleAddResourceToResourceGroupRequest,
  handleAddResourceToResourceGroupSuccess,
  handleAddResourceToResourceGroupFailure,
} from "./addResource";
import {
  handleRemoveResourceFromResourceGroupRequest,
  handleRemoveResourceFromResourceGroupSuccess,
  handleRemoveResourceFromResourceGroupFailure,
} from "./removeResource";
import { handleRemoveResourceFromPlanzoneSucceeded } from "./removeResourceFromPlanzone";
import { handleRemoveResourceFromProjectSucceeded } from "./removeResourceFromProject";

const initialState = { ...group, uuid: id };

function propagateEvent(
  state = initialState,
  event: Event,
): Identifiable<Group> {
  return {
    ...state,
    resources:
      state.resourceType === "planzone"
        ? state.resources.map((resource) => reduceResource(resource, event))
        : state.resources.map((resource) =>
            reduceProjectResource(resource, event),
          ),
  };
}

const reduceResourceGroup = createStateReducer(
  initialState,
  {
    [events.editResourceGroupRequested]: handleEditRequest,
    [events.editResourceGroupSucceeded]: handleEditSuccess,
    [events.editResourceGroupFailed]: handleEditFailure,
    [events.addResourceToResourceGroupRequested]:
      handleAddResourceToResourceGroupRequest,
    [events.addResourceToResourceGroupSucceeded]:
      handleAddResourceToResourceGroupSuccess,
    [events.addResourceToResourceGroupFailed]:
      handleAddResourceToResourceGroupFailure,
    [events.addEveryoneToResourceGroupSucceeded]:
      handleAddEveryoneToResourceGroupSuccess,
    [events.removeResourceFromResourceGroupRequested]:
      handleRemoveResourceFromResourceGroupRequest,
    [events.removeResourceFromResourceGroupSucceeded]:
      handleRemoveResourceFromResourceGroupSuccess,
    [events.removeResourceFromResourceGroupFailed]:
      handleRemoveResourceFromResourceGroupFailure,
    [events.removeResourceFromPlanzoneSucceeded]:
      handleRemoveResourceFromPlanzoneSucceeded,
    [events.removeResourceFromProjectSucceeded]:
      handleRemoveResourceFromProjectSucceeded,
  },
  propagateEvent,
);

export { reduceResourceGroup };
